import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=76af5454&scoped=true&"
import script from "./Bookmark.js?vue&type=script&lang=js&"
export * from "./Bookmark.js?vue&type=script&lang=js&"
import style0 from "./Bookmark.scss?vue&type=style&index=0&id=76af5454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af5454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
